// Hosts that block iframes (X-Frame-Options / frame-ancestors) — force new tab
const NEWTAB_HOST_PATTERNS = [
  /b2clogin\.com$/i,
  /login\.microsoftonline\.com$/i,
  /loginsaml\.aspx/i,
  /memberlink\.seiu1021\.org$/i,
  /sharepoint\.com$/i,
  /adobesign\.com$/i,
  /seiumb\.com$/i, // X-Frame-Options: SAMEORIGIN
  /callhub\.io$/i, // CSP frame-ancestors excludes this portal
];

// True when a URL's host is known to refuse iframe embedding (X-Frame-Options
// or frame-ancestors). Such URLs must open in a new tab; embedding them in
// /view only produces a blank frame.
export function isUnframableUrl(rawUrl) {
  try {
    const u = new URL(rawUrl);
    return NEWTAB_HOST_PATTERNS.some((re) => re.test(u.hostname) || re.test(u.href));
  } catch {
    return false;
  }
}

function isNewTabItem(item) {
  if (item.behavior === "newtab") return true;
  if (item.behavior === "inline") return false;
  if (item.type === "external") return isUnframableUrl(item.url);
  return false;
}

export function resolveItemUrl(item) {
  switch (item.type) {
    case "route":
      return item.route;
    case "external": {
      if (isNewTabItem(item)) return item.url;
      const params = new URLSearchParams({ url: item.url, title: item.title || "" });
      return `/view?${params.toString()}`;
    }
    case "pdf":
      return `/doc/${item.path}`;
    default:
      return "#";
  }
}

export function isExternalLink(item) {
  return isNewTabItem(item);
}
